<template>
  <div>
    <el-tabs type="card" v-model="currentTab">

    <el-tab-pane name="Insurer" label="Insurance Policy">
      <insurance-policy :row-data="rowData" :site-id="rowData.site_id" :site-name="siteName" />
    </el-tab-pane>


    <el-tab-pane v-if="isManager('finance')" name="statement" label="Statement">
       <insurance-statement :rowData="rowData"  :site-id="rowData.site_id" :site-name="siteName" />
    </el-tab-pane>

  </el-tabs>

  <div v-if="rowData.updated_at">
    <hr />
    <span class="pull-right">Last update: <b>{{formatFriendlyDate(rowData.updated_at)}}</b><span v-if="rowData.updated_by"> by {{rowData.updated_by}}</span></span>
  </div>

  </div>

</template>


<script>

import SiteMixins from '@/mixins/SiteMixins'

import InsurancePolicy from '@/components/sites/insurance/InsurancePolicy'
import InsuranceRenewal from '@/components/sites/insurance/InsuranceRenewal'

import InsuranceStatement from '@/components/sites/insurance/InsuranceStatement'

export default {
  components: {
    InsurancePolicy,
    InsuranceRenewal,
    InsuranceStatement
  },

  mixins: [SiteMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    },

    siteId: {
      type: Number,
      default: null
    },

    clientSiteId: {
      type: String,
      default: null
    },

    siteName: {
      type: String,
      default: null
    },

    editable: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      currentTab: 'Insurer'
    }
  }

}

</script>



// WEBPACK FOOTER //
// InsuranceDetails.vue?cd25e784